// Patch 30: "open a ticket" without loading the ticket form up front.
// The form (components/Tickets → TicketHost) downloads the first time it's needed.
let ready = false;
let pending = null;

export function openTicket(preset = {}) {
  if (ready) {
    window.dispatchEvent(new CustomEvent("tier:ticket", { detail: preset }));
    return;
  }
  pending = preset;
  window.dispatchEvent(new Event("tier:ticket-load"));
}

export function ticketHostReady() {
  ready = true;
  if (pending) {
    const p = pending;
    pending = null;
    setTimeout(() => openTicket(p), 0);
  }
}
